import get from 'lodash/get';
import Browser from '@wetransfer/concorde-browser';

import { optimizePath } from '../../helpers/optimize-path';
import { wallpaperFormat } from '../../helpers/wallpaper-format';

import request from '@module/http/axios/request';

export const MobileProvider = {
  get name() {
    return 'MOBILE_PROVIDER';
  },

  isRotationEnabled() {
    return true;
  },

  rotationInterval(config) {
    return config.defaultRotationInterval;
  },

  // Show editorial wallpapers when:
  // - we are on mobile
  test() {
    if (Browser.isMobile) return true;

    return false;
  },

  async nextCreative(config) {
    const response = await request({
      path: config.editorialUrl,
      params: {
        utm_source: 'mobile',
        utm_reason: null,
      },
    });

    return this.parseResponse(config, response.body);
  },

  parseResponse(config, response) {
    const src = response.src;

    return {
      src: optimizePath({ src: `${config.host}${src}` }),
      format: wallpaperFormat(src),
      meta: {
        href: get(response, 'meta.href', ''),
        title: get(response, 'meta.title', ''),
      },
    };
  },
};
